import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBAiFRR6TbRuZiN118gCfsmfAqHrHxJTY4",
    authDomain: "dluhy-2d3bd.firebaseapp.com",
    databaseURL: "https://dluhy-2d3bd.firebaseio.com",
    projectId: "dluhy-2d3bd",
    storageBucket: "dluhy-2d3bd.appspot.com",
    messagingSenderId: "90100379355",
    appId: "1:90100379355:web:4b63b606824278f43ca6fe",
    measurementId: "G-QVKJG0MY8Y"
};
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();
